/**
 * @flow
 */
'use strict';

export const occupationPrincipaleCodes = [
{"code":"1ere année"},
{"code":"2e année"},
{"code":"3e année"},
{"code":"3eme année"},
{"code":"4e année"},
{"code":"4ème année"},
{"code":"5e année"},
{"code":"5e secondaire"},
{"code":"6e année"},
{"code":"6ème année"},
{"code":"A la maison"},
{"code":"Abipa"},
{"code":"Accompagnement"},
{"code":"Accountant"},
{"code":"Acheteur"},
{"code":"Actuaire"},
{"code":"Acupuunture"},
{"code":"Adjointe administrative"},
{"code":"Administation "},
{"code":"Administration"},
{"code":"Aeronautique"},
{"code":"Agence revenu canada"},
{"code":"Agene voyage"},
{"code":"Agent de bord"},
{"code":"Agent de correction"},
{"code":"Agent de recherche"},
{"code":"Agent de sécurité"},
{"code":"Agent de voyage"},
{"code":"Agent formation"},
{"code":"Agent immobilier"},
{"code":"Agent location"},
{"code":"Agent protection faune"},
{"code":"Agent sécurité"},
{"code":"Agente de probation"},
{"code":"Agriculture"},
{"code":"Aide operateur"},
{"code":"Aide sociale"},
{"code":"Aide à domicile"},
{"code":"Alcoa"},
{"code":"Alimentation"},
{"code":"Ambulancier"},
{"code":"Amenagement paysager"},
{"code":"Analyste"},
{"code":"Ancienne infirmiere"},
{"code":"Animateur"},
{"code":"Animatrice"},
{"code":"Architecte"},
{"code":"Archiviste"},
{"code":"Arrêt de travail"},
{"code":"Arrêt pour le moment"},
{"code":"Arts martiaux"},
{"code":"Assembleur"},
{"code":"Assistante"},
{"code":"Assistante -recherche"},
{"code":"Assistante dentaire"},
{"code":"Assistante-tech."},
{"code":"Assurance emploi"},
{"code":"Assurances"},
{"code":"Astrologue"},
{"code":"Aucun"},
{"code":"Audio-visuel"},
{"code":"Audiologiste"},
{"code":"Audioprothésiste"},
{"code":"Auxilière familial"},
{"code":"Avocat"},
{"code":"Avocate"},
{"code":"Aéronautique"},
{"code":"Aéroport"},
{"code":"Banque"},
{"code":"Banquier"},
{"code":"Bell"},
{"code":"Bell helicopter"},
{"code":"Bibliothèque"},
{"code":"Biochimiste"},
{"code":"Biologiste"},
{"code":"Biotechnologie"},
{"code":"Bombardier"},
{"code":"Boucher"},
{"code":"Boulangerie"},
{"code":"Brigadière"},
{"code":"Briqueleur"},
{"code":"Bureau"},
{"code":"Bénévolat"},
{"code":"CSST/construction"},
{"code":"Cafétéria"},
{"code":"Caissier caissière"},
{"code":"Camionneur"},
{"code":"Cartographe"},
{"code":"Cegep"},
{"code":"Centre appels"},
{"code":"Ceramiste"},
{"code":"Chargé de projet"},
{"code":"Chariot élévateur"},
{"code":"Chauffeur"},
{"code":"Chauffeur autobus"},
{"code":"Chauffeur autobus scolaire"},
{"code":"Chauffeur autocar"},
{"code":"Chauffeur camion"},
{"code":"Chauffeur taxi"},
{"code":"Chef cuisinier"},
{"code":"Chimiste"},
{"code":"Chiropraticien"},
{"code":"Choriste"},
{"code":"Climatisation"},
{"code":"Coiffeur/Coiffeuse"},
{"code":"Col bleu"},
{"code":"Commis"},
{"code":"Commis de bureau"},
{"code":"Commis douanes"},
{"code":"Commis entrepot"},
{"code":"Communication"},
{"code":"Comp"},
{"code":"Comptabilité"},
{"code":"Comptable"},
{"code":"Comptable-Fiscaliste"},
{"code":"Comédien"},
{"code":"Concierge"},
{"code":"Conducteur train"},
{"code":"Conduit camion"},
{"code":"Conduit taxi"},
{"code":"Conduteur autobus scolaire"},
{"code":"Congé de maternité"},
{"code":"Conseiller en vente"},
{"code":"Conseiller financier"},
{"code":"Conseiller municipal"},
{"code":"Conseiller technique"},
{"code":"Conseillier technique"},
{"code":"Conseillère"},
{"code":"Construction"},
{"code":"Consultant"},
{"code":"Contre-maître"},
{"code":"Controleur financier"},
{"code":"Controleur routier"},
{"code":"Contruction"},
{"code":"Contrôle qualité"},
{"code":"Contrôleur"},
{"code":"Contrôleur aérien"},
{"code":"Coordonnatrice"},
{"code":"Cosmeitque"},
{"code":"Cosméticienne"},
{"code":"Coupe des arbres"},
{"code":"Coupeur "},
{"code":"Coupeur acier"},
{"code":"Courrier"},
{"code":"Cours conduite"},
{"code":"Courtier assurances"},
{"code":"Courtier douane"},
{"code":"Courtier finance"},
{"code":"Courtier immobilier"},
{"code":"Courtier valeur mobilière"},
{"code":"Couturière"},
{"code":"Criminologue"},
{"code":"Cuisinier"},
{"code":"Culture maréchère"},
{"code":"Danseur"},
{"code":"Decoupage"},
{"code":"Deigner industriel"},
{"code":"Dentiste"},
{"code":"Denturologiste"},
{"code":"Dep soutien informatique"},
{"code":"Dermatologue"},
{"code":"Designer"},
{"code":"Desinatrice mode"},
{"code":"Dessinateur"},
{"code":"Directeur "},
{"code":"Directeur directrice"},
{"code":"Directeur funéraire"},
{"code":"Directeur-adjoint"},
{"code":"Dispach/ordi"},
{"code":"Documentation"},
{"code":"Douanier"},
{"code":"Débossage"},
{"code":"Décorateur"},
{"code":"Déménagement"},
{"code":"Député fed."},
{"code":"Ecole à la maison"},
{"code":"Educatrice"},
{"code":"Educatrice RSG"},
{"code":"Elagage"},
{"code":"Electricien"},
{"code":"Electrolyse"},
{"code":"Electromécanicien"},
{"code":"Electronique"},
{"code":"Electrotechnicien"},
{"code":"Emballeur"},
{"code":"Encadrement"},
{"code":"Enqueteur"},
{"code":"Enseignant"},
{"code":"Enseignante"},
{"code":"Entraineur"},
{"code":"Entrepreneur"},
{"code":"Entrepôt"},
{"code":"Entretien"},
{"code":"Entretien auto"},
{"code":"Entretien ménager"},
{"code":"Ergonome"},
{"code":"Ergothérapeute"},
{"code":"Essilor"},
{"code":"Esthéticienne"},
{"code":"Estimation"},
{"code":"Etudiant"},
{"code":"Etudiante"},
{"code":"Evaluateur"},
{"code":"Examen annuel"},
{"code":"Experte en sinitre"},
{"code":"Expédition"},
{"code":"Facteur"},
{"code":"Ferblantier"},
{"code":"Finance"},
{"code":"Financement"},
{"code":"Fini secondaire"},
{"code":"Fiscaliste"},
{"code":"Fleuriste"},
{"code":"Fokker Elmo"},
{"code":"Fonctionnaire"},
{"code":"Fonctionnaire provincial"},
{"code":"Formation RH"},
{"code":"Frigorification"},
{"code":"Garage"},
{"code":"Garderie"},
{"code":"Gerante restaurant"},
{"code":"Gestion"},
{"code":"Golf"},
{"code":"Gouvernement federal"},
{"code":"Graphisme"},
{"code":"Guide"},
{"code":"Génie civilee"},
{"code":"Géologue"},
{"code":"Gérant"},
{"code":"Heroux devtek"},
{"code":"Histopathologie"},
{"code":"Horticulteur"},
{"code":"Huissier"},
{"code":"Hydro"},
{"code":"Hygiéniste"},
{"code":"Illustrateur"},
{"code":"Imprimerie"},
{"code":"Industrie pharmaceutique"},
{"code":"Infirmier"},
{"code":"Infirmiere Bellevue"},
{"code":"Infirmiere auxilliaire"},
{"code":"Infirmière"},
{"code":"Infographie"},
{"code":"Informaticien"},
{"code":"Informatique"},
{"code":"Ingénieur"},
{"code":"Inhalothérapeute"},
{"code":"Inspection"},
{"code":"Intervenant"},
{"code":"Invalidité"},
{"code":"Jointeur"},
{"code":"Journaliste"},
{"code":"Kung foo teacher"},
{"code":"Kénisologie"},
{"code":"Labo SDL"},
{"code":"Laboratoire"},
{"code":"Laveur auto"},
{"code":"Lecture"},
{"code":"Littérature"},
{"code":"Livraison"},
{"code":"Loisir"},
{"code":"Machiniste"},
{"code":"Mailman"},
{"code":"Maintenance"},
{"code":"Maison"},
{"code":"Maitrise"},
{"code":"Maitrise info"},
{"code":"Makeup artist"},
{"code":"Manequin"},
{"code":"Manoeuvre"},
{"code":"Manucuriste"},
{"code":"Manutention"},
{"code":"Maquilleuse "},
{"code":"Marechal ferrant"},
{"code":"Marketing"},
{"code":"Massothérapie"},
{"code":"Maternelle"},
{"code":"Maternelle en sept."},
{"code":"Mazda"},
{"code":"Maçon"},
{"code":"Mecanicien"},
{"code":"Med nucléaire"},
{"code":"Medecin"},
{"code":"Medecine familiale"},
{"code":"Menuisier"},
{"code":"Metallurgie"},
{"code":"Microbiologiste"},
{"code":"Min. transport"},
{"code":"Montage"},
{"code":"Montage de salle"},
{"code":"Monteur"},
{"code":"Mosaique"},
{"code":"Moulage"},
{"code":"Musicien"},
{"code":"Mécanicien"},
{"code":"Mécanicien aviation"},
{"code":"Mécanicien entretien"},
{"code":"Médecin"},
{"code":"Médecin général"},
{"code":"Naturopathe"},
{"code":"Neuro-psycho"},
{"code":"Notaire"},
{"code":"Nutritionniste"},
{"code":"Opticien"},
{"code":"Optometriste"},
{"code":"Opérateur"},
{"code":"Ordi"},
{"code":"Ordi +++"},
{"code":"Ordinateur"},
{"code":"Orthodontiste"},
{"code":"Orthopedagogue"},
{"code":"Orthophoniste"},
{"code":"Orthésite"},
{"code":"Orthésite Chabot"},
{"code":"Ostépathe"},
{"code":"Patisserie"},
{"code":"Paysagement"},
{"code":"Peintre"},
{"code":"Peinture"},
{"code":"Peinture auto"},
{"code":"Pepiniere"},
{"code":"Perfusionniste"},
{"code":"Pharmaceutique"},
{"code":"Pharmacie"},
{"code":"Pharmacien"},
{"code":"Photographe"},
{"code":"Photographie"},
{"code":"Physiothérapeute"},
{"code":"Pianiste"},
{"code":"Pilates"},
{"code":"Pilote"},
{"code":"Planification"},
{"code":"Platrier"},
{"code":"Plombier"},
{"code":"Plongeur (vaisselle"},
{"code":"Podiatre"},
{"code":"Policier"},
{"code":"Policière"},
{"code":"Pompier"},
{"code":"Pompiste"},
{"code":"Pose-ongle"},
{"code":"Poste canada"},
{"code":"Producteur radio"},
{"code":"Production"},
{"code":"Prof edu.physique"},
{"code":"Prof marketing"},
{"code":"Prof musique"},
{"code":"Professeur"},
{"code":"Professeur yoga"},
{"code":"Programmeur"},
{"code":"Pré-maternelle"},
{"code":"Pré-retraite"},
{"code":"Préposé"},
{"code":"Préposé alimentation"},
{"code":"Préposé au bénéficiaire"},
{"code":"Présentation visuelle"},
{"code":"Psychoeducation"},
{"code":"Psychologue"},
{"code":"Psychologue école"},
{"code":"Psychothérapeute"},
{"code":"Publicité"},
{"code":"Radiologie"},
{"code":"Recherche"},
{"code":"Recherche emploi"},
{"code":"Recherche fondammental"},
{"code":"Recouvrement"},
{"code":"Reflexologue"},
{"code":"Relation travail"},
{"code":"Remorqueur"},
{"code":"Renovation"},
{"code":"Représentant"},
{"code":"Représentant instrum. mus"},
{"code":"Représentant instrum. mus."},
{"code":"Resp.service garde école"},
{"code":"Ressource humaine"},
{"code":"Restaurateur"},
{"code":"Retraite"},
{"code":"Retraité"},
{"code":"Revetement ext"},
{"code":"Route"},
{"code":"Réceptionniste"},
{"code":"Réfrégération"},
{"code":"Répartiteur"},
{"code":"Résident médecine"},
{"code":"S.D.L."},
{"code":"Sablage "},
{"code":"Sc.humaines"},
{"code":"Sec.1"},
{"code":"Sec.2"},
{"code":"Sec.3"},
{"code":"Sec.4"},
{"code":"Sec.5"},
{"code":"Secrétaire"},
{"code":"Secrétaire médicale"},
{"code":"Secétaire"},
{"code":"Semi-retraite"},
{"code":"Serrurier"},
{"code":"Service alimentaire"},
{"code":"Service de garde"},
{"code":"Service de table"},
{"code":"Service à la clientèle"},
{"code":"Signaleur"},
{"code":"Soins de pied"},
{"code":"Sommelier"},
{"code":"Soudeur"},
{"code":"Styliste"},
{"code":"Superviseur"},
{"code":"Sur la route"},
{"code":"Surintendant"},
{"code":"Surveillante"},
{"code":"Système alarme"},
{"code":"Sécurité routière"},
{"code":"Tanatologue"},
{"code":"Tatoueur"},
{"code":"Tech.ambulancier"},
{"code":"Tech.labo pharmacie"},
{"code":"Tech.policiere"},
{"code":"Technicien"},
{"code":"Technicien de laboratoire"},
{"code":"Technicien dentaire"},
{"code":"Technicien loisir"},
{"code":"Technicien ordi"},
{"code":"Technicien vidéotron"},
{"code":"Technicienne juridique"},
{"code":"Technicienne radiologie"},
{"code":"Technicienne vétérinaire"},
{"code":"Telemarketing"},
{"code":"Thanatologue"},
{"code":"Thechnologue"},
{"code":"Thérapeute"},
{"code":"Toilettage chien"},
{"code":"Traders bourse"},
{"code":"Traduction"},
{"code":"Traiteur"},
{"code":"Travail dans entrepôt"},
{"code":"Travail de bureau"},
{"code":"Travail manuel"},
{"code":"Travail pieces avion"},
{"code":"Travailleuse sociale"},
{"code":"Trifileur"},
{"code":"Tuyauteur"},
{"code":"UNIVERSITÉ"},
{"code":"Urbaniste"},
{"code":"Urgence santé"},
{"code":"Valet auto"},
{"code":"Velan"},
{"code":"Vendeur"},
{"code":"Vendeur automobile"},
{"code":"Vendeuse"},
{"code":"Violoniste"},
{"code":"Vérificateur"},
{"code":"Vétérinaire"},
{"code":"Ébéniste"},
{"code":"Économiste"},
{"code":"Écrivain"},
{"code":"Éducateur"},
{"code":"Éducatrice en service de garde"},
{"code":"Éducatrice spécialisée"},
{"code":"Électricien"},
{"code":"Élevage chien"},
{"code":"Étalagiste"},
{"code":"Étudiant"},
{"code":"Étudiant en sec. 5"},
{"code":"Étudiant génie mécanique"},
{"code":"Étudiante"},
{"code":"Évaluateur en bâtiment"},
]
